import { OwnProps } from '~/types/ownProps';

const step = {
  route: '/homeowners-insurance/quotes/property-followup',
  isAccessible: ({ application: { isAutoOnly } }: OwnProps) => !isAutoOnly,
  breadcrumbStep: 'property',
};

export default step;
